import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const FlexiInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Flexi"
    sectionDisplayName="Flexi Section"
    backRoute="/sections/flexi"
  />
);

export default FlexiInwardConsignment;
